module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "front"
  }, [_vm._v("BEHIND THE SMILE")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/14_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("The Caribbean.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "height": "auto",
      "width": "auto",
      "margin": "0px 0px 0px 0px",
      "padding": "0px 0px 0px 0px",
      "border": "0px"
    },
    attrs: {
      "alt": "images",
      "src": "images/15_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig-caption"
  }, [_vm._v("Barbados with parish boundaries identified.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e45086","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front1.vue
// module id = 75
// module chunks = 0